"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WidgetResultComponent = void 0;
var WidgetResultComponent;
exports.WidgetResultComponent = WidgetResultComponent;

(function (WidgetResultComponent) {
  WidgetResultComponent["Share"] = "share";
  WidgetResultComponent["ResultInformation"] = "result-information";
})(WidgetResultComponent || (exports.WidgetResultComponent = WidgetResultComponent = {}));